<template>
    <div id="chart2">
        <apexchart
            style="height:max-content; width:400px ; background-color: transparent; margin-top: auto; margin-bottom: auto;"
            type="bar" :options="chartOptions" :series="series">
        </apexchart>
    </div>
</template>

<style>
.list-cate {
    background-color: transparent;
    height: max-content;
    margin-top: auto;
    margin-bottom: auto;
}

.itemlist {
    font-size: 10pt;
    background-color: #f2f2f2;
    width: 270px;
    padding: 5px 10px;
    border-radius: 5px;
    box-sizing: border-box;
    margin-top: 10px;
    overflow: hidden;
    white-space: nowrap;
    margin-bottom: 10px;
    text-overflow: ellipsis;
}
</style>

<script>
export default {
    props: {
        parseData: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            series: [{
                data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
            }],
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 350
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        borderRadiusApplication: 'end',
                        horizontal: true,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    categories: [],
                }
            },
        }
    },
    watch: {
        // 🔁 Update chart setiap kali parseData berubah
        parseData: {
            handler() {
                this.updateChart();
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.chartOptions.xaxis = {categories : []}
        this.updateChart();
    },
    methods: {
        updateChart() {
            if (this.parseData) {
                this.series[0] = {data : []}
                this.series[0].data = this.parseData.jumlah
                this.list_category = this.parseData.label
                this.chartOptions.xaxis.categories = this.parseData.label
                console.log(this.parseData)
            } else {
                this.series = [];
            }

        },
    }
}
</script>
